export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтверждение"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы уверены, что хотите продолжить?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить крипто-актив"])}
}